import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const SectionHeader = ({ eyebrow, title, description, href, linkLabel = "View all" }) => (
  <div className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div className="max-w-xl">
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 className="mt-2 font-serif text-3xl font-semibold tracking-tight sm:text-4xl">{title}</h2>
      {description && <p className="mt-3 text-ab-muted">{description}</p>}
    </div>
    {href && <Link to={href} className="btn-ghost shrink-0" data-testid={`section-link-${href.replace(/\//g, "") || "home"}`}>{linkLabel} <ArrowRight size={15} /></Link>}
  </div>
);
